import React from "react";
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  Divider,
  Container,
} from "@mui/material";
import { Lightbulb, WarningAmber, ThumbUp } from "@mui/icons-material";
import BackBtn from "../../widgets/BackBtn";

const WabaQualityGuide = () => {
  return (
    <Container sx={{ mt: 3 }} maxWidth="md">
      <BackBtn />
      <Card
        sx={{
          mt: 2,
          borderRadius: "16px",
          boxShadow: 3,
          background: "linear-gradient(to bottom right, #f9f9f9, #ffffff)",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            gutterBottom
            sx={{ fontWeight: "bold", textAlign: "center" }}
          >
            🚀 Crash Course: Keeping Your WABA Quality High
          </Typography>

          <Divider sx={{ mb: 2 }} />

          <Box sx={{ mb: 2 }}>
            <Typography
              variant="subtitle1"
              sx={{ display: "flex", alignItems: "center", fontWeight: "bold" }}
            >
              <Lightbulb sx={{ mr: 1, color: "orange" }} /> Golden Rules
            </Typography>
            <List dense>
              <ListItem>
                <ListItemText primary="✅ Send only relevant and expected messages – avoid spamming." />
              </ListItem>
              <ListItem>
                <ListItemText primary="🤝 Get **clear user consent** before sending templates." />
              </ListItem>
              <ListItem>
                <ListItemText primary="🔍 Keep templates **short, clear, and professional**." />
              </ListItem>
              <ListItem>
                <ListItemText primary="💡 Personalize messages – don’t look like bulk SMS." />
              </ListItem>
              <ListItem>
                <ListItemText primary="⏱️ Respect frequency – don’t overwhelm users." />
              </ListItem>
            </List>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography
              variant="subtitle1"
              sx={{ display: "flex", alignItems: "center", fontWeight: "bold" }}
            >
              <ThumbUp sx={{ mr: 1, color: "green" }} /> Best Practices
            </Typography>
            <List dense>
              <ListItem>
                <ListItemText primary="📊 Monitor template performance & block underperforming ones." />
              </ListItem>
              <ListItem>
                <ListItemText primary="📞 Provide easy opt-out (e.g. 'Reply STOP to unsubscribe')." />
              </ListItem>
              <ListItem>
                <ListItemText primary="🎯 Segment users – send the right info to the right audience." />
              </ListItem>
              <ListItem>
                <ListItemText primary="🕒 Time it well – don’t send at odd hours." />
              </ListItem>
              <ListItem>
                <ListItemText primary="⭐ Ask feedback politely & improve messaging tone." />
              </ListItem>
            </List>
          </Box>

          <Box>
            <Typography
              variant="subtitle1"
              sx={{ display: "flex", alignItems: "center", fontWeight: "bold" }}
            >
              <WarningAmber sx={{ mr: 1, color: "red" }} /> Things to Avoid
            </Typography>
            <List dense>
              <ListItem>
                <ListItemText primary="🚫 Don’t use clickbait or misleading offers." />
              </ListItem>
              <ListItem>
                <ListItemText primary="🚫 Avoid repetitive follow-ups if user ignores." />
              </ListItem>
              <ListItem>
                <ListItemText primary="🚫 Never send sensitive, abusive, or irrelevant content." />
              </ListItem>
            </List>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Typography
            variant="body1"
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              color: "green",
              background: "#e8f5e9",
              borderRadius: "8px",
              p: 1.5,
            }}
          >
            🎉 Summary: Keep it relevant, respectful & personalized → Your WABA
            stays green 🌟
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default WabaQualityGuide;
